import axios from 'axios';

// The global axios interceptor (src/index.js) already injects credentials, the
// auth header, pathRewrite, and Meta cookies — so the query layer reuses the
// same configured axios rather than a second instance with divergent config.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios;

export const apiGet = (url, config) => axios.get(url, config).then((r) => r.data);
export const apiPost = (url, body, config) => axios.post(url, body, config).then((r) => r.data);
export const apiPut = (url, body, config) => axios.put(url, body, config).then((r) => r.data);
export const apiPatch = (url, body, config) => axios.patch(url, body, config).then((r) => r.data);
export const apiDelete = (url, config) => axios.delete(url, config).then((r) => r.data);
